module.exports = __webpack_public_path__ + "static/media/low_battery.9ba4ded3.svg";